import React from 'react';
import Button from 'ROOT/src/components/formElements/Button';
import sAction from 'sAction';
import ResetPassRequest_orig from 'ROOT/src/components/login/ResetPassRequest';

export default class ResetPassRequest extends ResetPassRequest_orig {
    render() {
        const ret = !this.state.error && this.state.message ? this.getMessage() : this.getForm();
        return (
            <>
                <div className="loginBoxContainer" onKeyDown={(e) => this.onKeyDown(e)}>
                    <p>{ret}</p>
                </div>
            </>
        );
    }

    getForm() {
        const errorMessage = this.state.errorMessage ? sAction.translate(this.state.errorMessage) : '';
        return (
            <>
                <h1 className="loginHeadline">{sAction.translate('LBL_RESET_PASSWORD')}</h1>

                <p className='errorMessageText'>{errorMessage}</p>

                <div className="loginInputWrapper">
                    <label>{sAction.translate('LBL_LOGIN_NAME')}</label>
                    <input type="text" className="loginInput" placeholder="" autoFocus={true} id="email" ref={this.name} />
                </div>

                <div className="signInBtnWrapper">
                    <a className="button full signInBtn" onClick={() => this.createResetPassRequest()}>
                        {sAction.translate('LBL_SUBMIT_BUTTON_LABEL')}
                    </a>
                </div>

                <div className="loginButtonContainer resetPassBackBtn">
                    {sAction.translate('LBL_FORGOTTEN_PASSWORD_RETURN')}
                        &nbsp;
                    <a onClick={() => this.props.goToLogin()}>
                        {sAction.translate('LBL_FORGOTTEN_PASSWORD_RETURN_BUTTON')}
                    </a>
                </div>
            </>
        );
    }
}
